import { RootState } from "../../store";

export const selectSearchingState = (state: RootState) => state.page.searching;
